import getActionStrReduxUtil from 'modules/redux/utils/get-action-str'
import {
  CUSTOMER_DOMAIN,
  CUSTOMER_ENDPOINT,
  CUSTOMER_KEY,
  CUSTOMER_PATH
} from 'modules/customer/redux/state'
import {
  REDUX_ACTION_PREFIX,
  REDUX_OPTION
} from 'modules/redux/constants'
import getSampleHistoryQuestionsCustomerSelect from 'modules/customer/redux/selectors/get-sample-history-questions'
import loadReduxAction from 'modules/redux/actions/load'
import mergeQuestionsUtil from 'modules/customer/redux/actions/load-sample-history/utils/merge'

export default function loadSampleHistoryCustomerAction (props) {
  return (dispatch, getState) => {
    const logLabel = 'loadSampleHistoryCustomerAction'
    logUtil(logLabel).debug('[start] props=', props)

    const key = CUSTOMER_KEY.SAMPLE_HISTORY
    const action = getActionStrReduxUtil(
      REDUX_ACTION_PREFIX.LOAD,
      CUSTOMER_DOMAIN,
      key
    )

    const existingQuestions = getSampleHistoryQuestionsCustomerSelect(getState())
    logUtil(logLabel).debug('existingQuestions=', existingQuestions)

    const endpoint = CUSTOMER_ENDPOINT.SAMPLE_HISTORY
    const path = CUSTOMER_PATH[key]
    return dispatch(
      loadReduxAction({
        action,
        path,
        logLabel,
        endpoint,
        query: props.query,
        options: {
          [REDUX_OPTION.NEEDS_AUTHENTICATION]: true,
          [REDUX_OPTION.MERGE_FUNCTION]: mergeQuestionsUtil
        }
      })
    )
  }
}
